<template>
  <div>
    <b-label label="Штатні одиниці на розгляд"></b-label>
    <div class="text-disabled font-size-11 mb-3">
      Введіть ПІБ співробітника, який має призначення на потрібну штатну
      одиницю, та оберіть зі списку. Можна додати декілька штатних одиниць.
    </div>
    <employee-autocomplete
      v-model="newReviewerId"
      :error-messages="
        getErrorMessages(v$.newReviewerId)
      "></employee-autocomplete>
    <b-textarea v-model="comment" label="Коментар (Необовʼязково)"></b-textarea>
  </div>
</template>

<script setup lang="ts">
import { BTextarea, BLabel } from 'best-modules/components'
import EmployeeAutocomplete from '@/components/inputs/employee-autocomplete/EmployeeAutocomplete.vue'
import { Dialog } from '@/dialog'
import { getErrorMessages } from 'best-modules/utils'
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { documentChangeReviewer } from '@/requests/document'

defineOptions({
  name: 'DocumentChangeReviewer',
})

const props = defineProps<{
  dialog: Dialog
}>()

const newReviewerId = ref<number>()
const comment = ref<string>()
const v$ = useVuelidate({ newReviewerId: { required } }, { newReviewerId })
const submit = () => {
  return documentChangeReviewer(props.dialog.dialogData.reviewId, {
    comment: comment.value,
    newReviewerId: newReviewerId.value,
  })
}

defineExpose({
  v$,
  submit,
})
</script>
